import type { Error404UmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import GenericNotFoundComponent from "#/_packages/umbrella/features/error-handling/components/not-found.tsx";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import PageNotFoundUmbPage from "#/_packages/umbrella/integrations/umbraco/components/pages/page-not-found-umb-page.tsx";

const NotFoundComponent = () => {
	const siteSettings = useGetSiteSettings();
	const page = siteSettings?.pageNotFoundPage;

	return page?.contentType === "error404UmbPage" &&
		Object.keys(page.properties ?? {}).length > 0 ? (
		<>
			<title>{page.name}</title>
			<PageNotFoundUmbPage
				content={page as Error404UmbPageContentResponseModel}
			/>
		</>
	) : (
		<GenericNotFoundComponent />
	);
};
export default NotFoundComponent;
